module.exports = __webpack_public_path__ + "img/background1.91d9b1f1.jpg";